import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { ASSETS } from "@/lib/assets";
import { SEO } from "@/components/SEO";

const ALL_LINKS = [
  { label: "Rottebekæmpelse", to: "/ydelser/rottebekaempelse" },
  { label: "Kloakopgaver", to: "/ydelser/kloakopgaver" },
  { label: "No-dig", to: "/ydelser/no-dig" },
  { label: "Spul & Rens", to: "/ydelser/spul-rens" },
];

export const Service = () => (
  <>
    <SEO
      title="Serviceaftale på kloak – Forebyg dyre skader"
      description="Fast serviceaftale på kloak og afløb: planlagt spuling, TV-inspektion og kontrol. Færre driftsstop, tidlig opdagelse af skader og rapport efter hvert besøg."
    />
    <ServicePageTemplate
    eyebrow="Serviceaftale"
    title={<>Forebyg problemer, <em className="text-[color:var(--fk-gold)]">før de bliver dyre.</em></>}
    subtitle="Med en fast serviceaftale holder vi øje med kloak og afløb, før problemerne vokser sig store. Det giver færre overraskelser, lavere risiko og en mere forudsigelig drift."
    heroImage={ASSETS.images.contract}
    intro="Pludselige kloakskader kan blive dyre, men mange kan opdages i tide. Med en fast serviceaftale holder vi øje med kloak og afløb, dokumenterer tilstanden og hjælper med at forebygge driftsstop."
    bullets={[
      "Fast plan for spuling, inspektion og kontrol",
      "Tidlig opdagelse af skader, tilstopninger og rotteveje",
      "Klar rapport efter hvert besøg",
      "Prioriteret hjælp ved akutte hændelser",
    ]}
    process={[
      { title: "Vurdering", body: "Vi gennemgår ejendommen, kloakken og de typiske risikopunkter, så aftalen tager udgangspunkt i det faktiske behov." },
      { title: "Aftale", body: "Vi sammensætter en serviceaftale med faste intervaller for kontrol, spuling, inspektion og opfølgning." },
      { title: "Service", body: "Vi udfører den aftalte service, dokumenterer arbejdet og reagerer, hvis vi finder tegn på skader eller begyndende problemer." },
      { title: "Rapport", body: "Efter hvert besøg får du en klar rapport med status, billeder og eventuelle anbefalinger til næste skridt." },
    ]}
    ctaHeading="Skal vi forebygge næste problem?"
    ctaBody="Book en gennemgang, så vurderer vi kloakken, risikopunkterne og hvilken serviceaftale der giver bedst mening for ejendommen."
    related={ALL_LINKS}
  />
  </>
);
